import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createSlots as _createSlots, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2874cdca"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "mandatory"
}
const _hoisted_2 = {
  key: 0,
  class: "row items-center justify-end"
}
const _hoisted_3 = { class: "date-warning" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_date = _resolveComponent("q-date")!
  const _component_q_popup_proxy = _resolveComponent("q-popup-proxy")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ 'unlabeled-date-picker': !$setup.hasLabel })
  }, [
    _createVNode(_component_q_input, _mergeProps({
      placeholder: $props.placeholder ?? $setup.t('SELECT_DATE'),
      class: { 'full-width': $props.fullWidth },
      onClick: $setup.showDatePickerProxy,
      disable: $props.disable
    }, $setup.inputProps, {
      "label-slot": $setup.hasLabel,
      error: !$setup.isValid,
      modelValue: $setup.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.value) = $event))
    }), _createSlots({
      label: _withCtx(() => [
        _createTextVNode(_toDisplayString($props.label) + " ", 1),
        ($props.mandatory)
          ? (_openBlock(), _createElementBlock("span", _hoisted_1))
          : _createCommentVNode("", true)
      ]),
      prepend: _withCtx(() => [
        _createVNode(_component_q_icon, {
          color: "grey-dark",
          size: $setup.iconSize,
          name: $setup.ICONS_NAME.CALENDAR_OUTLINE
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_popup_proxy, _mergeProps({ ref: "datePickerProxy" }, $setup.DATE_PICKER_ITEM, {
              onShow: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:focus')))
            }), {
              default: _withCtx(() => [
                _createVNode(_component_q_date, {
                  mask: $setup.DATE_FORMAT.LOCAL_DATE_PICKER,
                  "navigation-min-year-month": $setup.minYearMonth,
                  "navigation-max-year-month": $setup.maxYearMonth,
                  options: $setup.availableDates,
                  "onUpdate:modelValue": [
                    $setup.hideDatePickerProxy,
                    _cache[0] || (_cache[0] = ($event: any) => (($setup.value) = $event))
                  ],
                  minimal: "",
                  "no-unset": "",
                  modelValue: $setup.value
                }, {
                  default: _withCtx(() => [
                    ($setup.dateIsSelected && $props.clearable)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                          _withDirectives(_createVNode(_component_q_btn, _mergeProps({ label: "Clear" }, $setup.BTN_SECONDARY_SM, { onClick: $setup.clearProxyDate }), null, 16, ["onClick"]), [
                            [_directive_close_popup]
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["mask", "navigation-min-year-month", "navigation-max-year-month", "options", "onUpdate:modelValue", "modelValue"])
              ]),
              _: 1
            }, 16)
          ]),
          _: 1
        }, 8, ["size", "name"])
      ]),
      error: _withCtx(() => [
        _createVNode(_component_q_icon, {
          name: $setup.ICONS_NAME.WARNING_SOLID
        }, null, 8, ["name"]),
        _createElementVNode("span", _hoisted_3, _toDisplayString($props.errorMessage), 1)
      ]),
      _: 2
    }, [
      ($props.hintSlot)
        ? {
            name: "hint",
            fn: _withCtx(() => [
              _renderSlot(_ctx.$slots, "hint", {}, undefined, true)
            ]),
            key: "0"
          }
        : undefined
    ]), 1040, ["placeholder", "class", "onClick", "disable", "label-slot", "error", "modelValue"])
  ], 2))
}